import React, { useState } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";

const OrderConfirmation = () => {
  const query = new URLSearchParams(window.location.search);
  const paymentType = query.get("type");
  const redirectUrl = query.get("redirect");
  const isApp = query.get("app");

  const [descriptionType, setDescriptionType] = useState(
    paymentType === "LIVE_EVENTS"
      ? "live conference"
      : paymentType === "REFERRAL"
        ? "patient referral profile"
        : paymentType === "PATIENT_REGISTRY"
          ? "patient progress report"
          : "", // default fallback if no match
  );

  if (!paymentType || !redirectUrl || !isApp) {
    return (
      <div className="loader-container">
        <h4>Un Authorized User</h4>
        <button className="orange-btn" onClick={redirectBack}>
          Go to Site
        </button>
      </div>
    );
  }

  const redirectBack = () => {
    window.location.href = `${process.env.REACT_APP_SITE_URL}`;
  };

  const goToApp = () => {
    window.location.href = `${redirectUrl}`;
  };

  return (
    <div style={{ backgroundColor: "#0D2C54", minHeight: "100vh" }}>
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Card
          className="shadow p-5 text-center"
          style={{ maxWidth: 500, width: "100%", borderRadius: "10px" }}
        >
          <div className="d-flex justify-content-center mb-3">
            <CheckCircleFill color="green" size={60} />
          </div>

          <h3 className="fw-bold">You’re Successfully Registered!</h3>

          <p className="text-muted mt-3 mb-1">
            {`Thank you for registering for the ${descriptionType}. Your payment has
            been received successfully.`}
          </p>
          <p className="text-muted mb-4">
            You will receive a confirmation email with event details, including
            the session link and agenda.
          </p>

          {/* <p className="text-muted">Registration Date: 14 Nov 2021</p> */}

          <Button
            style={{ background: "#0D2C54" }}
            className="mt-3 px-4 py-2"
            onClick={goToApp}
          >
            Return to App
          </Button>
        </Card>
      </Container>
    </div>
  );
};

export default OrderConfirmation;
